import { render, staticRenderFns } from "./MessageCollectionButton.vue?vue&type=template&id=2ca1212c&scoped=true"
import script from "./MessageCollectionButton.vue?vue&type=script&lang=ts"
export * from "./MessageCollectionButton.vue?vue&type=script&lang=ts"
import style0 from "./MessageCollectionButton.vue?vue&type=style&index=0&id=2ca1212c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1212c",
  null
  
)

export default component.exports